import { createAction, props } from "@ngrx/store";
import ICertification from "@skills-app/models/certification";
import { SortParameters } from "@skills-app/models/sorting";

const prefix = "[Certifications Page]";

export const requestAllCertifications = createAction(
  `${prefix} Request All Certifications`,
);

export const requestAllCertificationsSuccess = createAction(
  `${prefix} Request All Certifications Success`,
  props<{ certifications: ICertification[] }>(),
);

export const requestAllCertificationsError = createAction(
  `${prefix} Request All Certifications Error`,
);

export const requestUpsertCertification = createAction(
  `${prefix} Request Upsert Certification`,
  props<{ certification: ICertification }>(),
);

export const requestUpsertCertificationError = createAction(
  `${prefix} Request Upsert Certification Error`,
);

export const requestDeleteCertification = createAction(
  `${prefix} Request Delete Certification`,
  props<{ certificationId: string }>(),
);

export const requestDeleteCertificationSuccess = createAction(
  `${prefix} Request Delete Certification Success`,
);

export const requestDeleteCertificationError = createAction(
  `${prefix} Request Delete Certification Error`,
);

export const updateSort = createAction(
  `${prefix} Update Certification Sort`,
  props<{ value: SortParameters }>(),
);

export const setOnlyRecentCertifications = createAction(
  `${prefix} Limit Certifications to last 3 months`,
  props<{ value: boolean }>(),
);
